import { FC, useCallback } from 'react';

import useSWR from 'swr';

import { AddDomainForm } from './addDomainForm/AddDomainForm';
import { DomainsTable } from './domainsTable/DomainsTable';

import css from './DomainPage.module.css';

import { domainService } from 'v2/api/domainService';
import { telegramAuthBotService } from 'v2/api/telegramAuthBotService';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';
import { usePagination } from 'v2/hooks/usePagination';

export const DomainPage: FC = () => {
  const pagination = usePagination();

  const { data: domainsData, mutate: mutateDomains } = useSWR(
    ['getDomains', pagination.page, pagination.pageSize],
    domainService.getDomains,
    { keepPreviousData: true }
  );

  const { data: bots, mutate: mutateBots } = useSWR('getTelegramAuthBots', telegramAuthBotService.getBots);

  const handleRevalidate = useCallback(() => {
    mutateDomains();
    mutateBots();
  }, [mutateDomains, mutateBots]);

  return (
    <PageLayout className={css.domainPage} overflow="hidden">
      <PageTitle>Domain Settings</PageTitle>

      <div className={css.domainPageContent}>
        <AddDomainForm onSuccess={mutateDomains} />

        <DomainsTable
          data={domainsData}
          pagination={pagination}
          onRevalidate={handleRevalidate}
          bots={bots ?? []}
          onRevalidateBots={mutateBots}
        />
      </div>
    </PageLayout>
  );
};
